import {Box, Button, Center, Flex} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import React, {useEffect, useState} from 'react'
import ContentTile from '../../components/content-tile'
import {useCommerceAPI} from '../../commerce-api/contexts'
import {Skeleton as AddToCartSkeleton} from '../../components/add-to-cart-cta'
import {FormattedMessage} from 'react-intl'
import useAsync from '../../commerce-api/hooks/useAsync'

const WidgetArticleGridView = ({sliderData, showLoadMore, moreResultsLink}) => {
    const api = useCommerceAPI()
    const [data, setData] = useState(sliderData)
    const [next, setNext] = useState(moreResultsLink)
    const [showButton, setShowButton] = useState(true)

    const {
        execute: getMoreResults,
        loading,
        data: result
    } = useAsync(api.contentSearch.getNextResults)

    useEffect(() => {
        if (result) {
            setNext(result.next)
            setData((data) => [...data, ...result.hits])
            if (result.start + result.count === result.total) {
                setShowButton(false)
            }
        }
    }, [result])

    return (
        <>
            <Box data-testid="grid-element">
                <Flex
                    flexWrap="wrap"
                    justifyContent={['center', 'flex-start']}
                    gap={['0', '24px']}
                    padding={['16px 32px 8px 32px', '16px 32px 32px 32px']}
                >
                    {data.map((item) => (
                        <Box
                            width={['100%', 'calc(100% / 3 - 17px)']}
                            paddingBottom={['24px', '0']}
                            key={item.id}
                        >
                            <ContentTile content={item} variant="default" ratio={4 / 3} />
                        </Box>
                    ))}
                </Flex>
                {loading && <AddToCartSkeleton />}
                {showLoadMore && showButton && (
                    <Center padding="2.5rem 1rem">
                        <Button
                            variant="outline"
                            width={['full', '25rem']}
                            data-testid="more-button"
                            onClick={() =>
                                getMoreResults({
                                    parameters: {
                                        next: next
                                    }
                                })
                            }
                        >
                            <FormattedMessage defaultMessage="Load more" id="global.loadmore" />
                        </Button>
                    </Center>
                )}
            </Box>
        </>
    )
}

WidgetArticleGridView.propTypes = {
    sliderData: PropTypes.array,
    setSliderData: PropTypes.func,
    showLoadMore: PropTypes.bool,
    moreResultsLink: PropTypes.string,
    setMoreResultsLink: PropTypes.func
}

export default WidgetArticleGridView
